import { InviteEmailConflict } from './invite-email-conflict.enum'

export type InviteEmailConflictScope = 'project' | 'workspace'

export class InviteEmailConflictError extends Error {
  readonly name = 'InviteEmailConflictError'

  constructor(
    readonly conflict: InviteEmailConflict,
    readonly scope: InviteEmailConflictScope
  ) {
    super(`Invite conflict: ${conflict} (${scope})`)
  }
}
